var initPhotoSwipeFromDOM = function (gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function (el) {
        var thumbElements = el.querySelectorAll('.pswp-item'),
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            captionEl,
            size,
            item;

        for (var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes
            if (figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.querySelector('.pswp-link');

            size = linkEl.getAttribute('data-size').split('x');

            var type = linkEl.getAttribute('data-type');

            if (type === 'video') {
                item = {
                    html: '<div class="pswp__video">' +
                        '<div class="iframe-wrapper">' +
                        '<iframe width="1060" height="600" src="' + linkEl.getAttribute('href') + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>' +
                        '</div>' +
                        '</div>',
                };
            } else {
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };
            }

            captionEl = figureEl.querySelector('.pswp-caption');
            if (captionEl) {
                item.title = captionEl.innerHTML;
            }

            item.msrc = linkEl.querySelector('.pswp-thumb').getAttribute('src');
            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;
        
        var clickedPointRelative = {
            x: Math.round(e.offsetX / eTarget.offsetWidth * 100) / 100,
            y: Math.round(e.offsetY / eTarget.offsetHeight * 100) / 100,
        };
        
        // find root element of slide
        var clickedListItem = closest(eTarget, function (el) {
            return (hasClass(el, 'pswp-item'));
        });

        if (!clickedListItem) {
            return;
        }

        // Jeśli klikniemy w YT to nie przekazujemy pozycji z kliknięcia, bo stosuje się ona do pobocznych elementów
        if(hasClass(clickedListItem, 'yt')) {
            clickedPointRelative = {
                x: 0,
                y: 0,
            };
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = closest(clickedListItem, function (el) {
            return (hasClass(el, 'pswp-gallery'));
        });


        var childNodes = clickedGallery.querySelectorAll('.pswp-item'),
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
                continue;
            }

            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }


        if (index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe(index, clickedGallery, false, false, clickedPointRelative);
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function () {
        var hash = window.location.hash.substring(1),
            params = {};

        if (hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL, clickedPointRelative) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);
        clickedPointRelative = typeof clickedPointRelative !== 'undefined' ? clickedPointRelative : {x: 0, y: 0};

        // define options (if needed)
        options = {

            // define gallery index (for URL)
            scaleMode: 'zoom',
            zoomBreakpoints: [
              [breakpoints.sm, 540],
              [breakpoints.md, 720],
              [breakpoints.lg, 960],
              [breakpoints.xl, 1272]
            ],
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            showHideOpacity: true,
            bgOpacity: 1,
            shareEl: false,
            closeOnVerticalDrag: false,
            clickedPointRelative: clickedPointRelative,

            getThumbBoundsFn: function (index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();

                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            }

        };

        // PhotoSwipe opened from URL
        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for (var j = 0; j < items.length; j++) {
                    if (items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
            return;
        }

        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();

        //todo-kt: ujednolicić ładowanie wideo ze strony głównej z tymi z photoswipea (może wspólna funkcja https://chromatichq.com/blog/working-youtube-player-api-iframe-embeds)
        var stopVideos = function () {
            document.querySelectorAll('.pswp__video iframe').forEach(function (item) {
                item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
            })
        };

        gallery.listen('beforeChange', stopVideos);
        gallery.listen('destroy', stopVideos);
        gallery.listen('initialZoomInEnd', function() {
            // automatycznie odtwarza video po kliknięciu w miniaturę
            var iframe = gallery.currItem.container.querySelector('.pswp__video iframe');
            if (iframe) {
                iframe.addEventListener('load', function () {
                    iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
                });

            }
        });


    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
};